export const WalletTransactionStatus = {
  PROCESSING: "processing",
  SETTLED: "settled",
  VOIDED: "voided",
} as const;
export type WalletTransactionStatus =
  (typeof WalletTransactionStatus)[keyof typeof WalletTransactionStatus];
